/*
 * @Author: wlo_o
 * @Date: 2022-03-09 15:30:25
 * @LastEditors: wlo_o
 * @LastEditTime: 2022-03-09 16:06:17
 * @FilePath: /frontend/lib/mixins/EventMixin.js
 * @Description: 定制一个事件相关方法
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */
export default {
  methods: {
    '$customEmit': function (eventName, ...arg) {
      console.log(eventName, ...arg)
      this.$OecpMetaDataEventBus.$emit('customEvent', eventName, ...arg)
    }
  }
}
